module.exports = __webpack_public_path__ + "static/media/daniel-olahs.1d8edbba.jpg";